const header = document.querySelector('header');
const button = document.getElementById('nav-icon');
const overlay = document.getElementById('nav-menu');
const label = document.getElementById('menu-text');

if (header && button && overlay) {
  let isOpen = false;
  let scrollY = 0;

  const focusableSelector = 'a[href], button:not([disabled])';

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    header.classList.add('menu-is-active');
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-label', 'Lukk meny');
    if (label) label.textContent = 'Lukk';
    lockScroll();

    // Move focus into the overlay (the container, not a link) so screen-reader
    // users land inside without a stray focus ring on the first link.
    overlay.focus({ preventScroll: true });

    document.addEventListener('keydown', onKeydown);
  }

  function close({ restoreFocus = true } = {}) {
    if (!isOpen) return;
    isOpen = false;
    header.classList.remove('menu-is-active');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Åpne meny');
    if (label) label.textContent = 'Meny';
    unlockScroll();

    document.removeEventListener('keydown', onKeydown);
    if (restoreFocus) button.focus({ preventScroll: true });
  }

  function toggle() {
    isOpen ? close() : open();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      close();
      return;
    }

    // Trap focus within the trigger + overlay while open.
    if (e.key === 'Tab') {
      const focusable = [button, ...overlay.querySelectorAll(focusableSelector)];
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  button.addEventListener('click', toggle);

  // Close when navigating to a link (don't steal focus from the destination).
  overlay.addEventListener('click', (e) => {
    if (e.target.closest('a')) close({ restoreFocus: false });
  });

  // Reset state if the viewport grows into the desktop (inline) menu.
  const desktopQuery = window.matchMedia('(min-width: 1024px)');
  desktopQuery.addEventListener('change', (e) => {
    if (e.matches && isOpen) close({ restoreFocus: false });
  });
}
